const steps = [
  { num: '1', title: 'Определить цель', desc: 'Что сотрудник должен уметь делать самостоятельно?' },
  { num: '2', title: 'Определить текущий уровень', desc: 'Что он уже умеет и чего ему не хватает.' },
  { num: '3', title: 'Показать стандарт', desc: 'Объяснить алгоритм, критерии результата и типичные ошибки.' },
  { num: '4', title: 'Дать попробовать', desc: 'Сотрудник выполняет задачу самостоятельно.' },
  { num: '5', title: 'Наблюдать', desc: 'Наставник оценивает процесс и результат.' },
  { num: '6', title: 'Дать обратную связь', desc: 'Разбираются конкретные действия и результат.' },
  { num: '7', title: 'Повторить', desc: 'Сотрудник применяет рекомендации на практике.' },
  { num: '8', title: 'Увеличить самостоятельность', desc: 'Наставник постепенно уменьшает объём контроля.' },
  { num: '9', title: 'Зафиксировать результат', desc: 'Определяются критерии, по которым сотрудник считается самостоятельным.' },
];

export default function MentoringSystem() {
  return (
    <section id="process" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как построить систему наставничества
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          От передачи опыта к самостоятельности сотрудника — последовательность, которая превращает разовую помощь в устойчивое развитие
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute left-[23px] top-8 bottom-8 w-0.5 bg-teal-200"></div>
          <div className="space-y-5">
            {steps.map((step) => (
              <div key={step.num} className="flex gap-5 items-start relative">
                <div className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center text-lg font-bold flex-shrink-0 z-10">
                  {step.num}
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 flex-1 hover:border-teal-300 transition-colors">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">{step.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}